import initSliderCards from '../shared/sliderCards';

interface NotFoundConfig {
  notFound: {
    similar: Array<{
      id: string;
      count: number
    }>;
  };
}

const initNotFound = ({ notFound }: NotFoundConfig): void => {
  notFound.similar.forEach(({
    id,
    count
  }) => {
    initSliderCards(id, count);
  });
};

export default initNotFound;
